import { useTranslation } from 'react-i18next';
import React, { useState, FC, useEffect } from "react";
import { Button, message } from "antd";
import { YHModal } from "@/erp_subpackage/components/YHModal";
import { usePsiModel } from "../../psiModel";
import { useGlobalModel } from "@/erp_subpackage/model/globalModel";
import { DetailsTable } from "./detailsTable";
import { IremainDetail, psiService } from "../../psiService";
import { convertRes2Blob } from "@/erp_subpackage/utils/exportFile";


// 进销存type io_spd采购明细 io_ssd销售明细(出库）occupy_ssd销售明细（占用）io_sprd采购退货明细 io_ssrd销售退货明细io_vmm维修物料明细(出入库)occupy_vmm维修物料明细(占用)io_vrm维修物料退货明细occupy_vam维修预约
//进销存剩余数
export const RemainNumModal = () => {
	const { t } = useTranslation();
	const {
		goodsRecordModal: { remainVisible: visible, row, type, title, field }, onCancel, shopId
	} = usePsiModel();
	const [recordType, setRecordType] = useState("io_spd");
	const [dataSource, setDataSource] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (visible && row) {
			loadData()
		}
	}, [visible])

	const loadData = async (str = type === "all" ? "io_spd" : type) => {
		setLoading(true);
		setRecordType(str)
		try {
			const searchParams = {
				shopId,
				materialCode: row?.materialCode,
				types: str.split(","),
			}
			let { retData } = await psiService.purchaseSaleStorageDeatil(searchParams);
			setDataSource(retData ?? []);
			setLoading(false)
		} catch {
			setLoading(false);
			setDataSource([])
		}
	}

	//导出
	const exportDetail = async () => {
		if (!dataSource.length) {
			message.warning(t(`stock.RemainNumModal.index.无数据`));
			return;
		}
		// setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
		try {
			const searchParams = {
				shopId,
				materialCode: row?.materialCode,
				types: recordType.split(","),
			}
			let result = await psiService.purchaseSaleStorageDeatilExport(searchParams);
			// result && setLoadingInfo({ loadingVisible: false, txt: "" });
			convertRes2Blob(result);
		} catch {
			// setLoadingInfo({ loadingVisible: false, txt: "" })
		}
	}


	const classname = (type) => {
		return 'btn-item tab-item ' + (recordType === type ? 'tab-active' : '')
	}

	return <YHModal
		visible={visible}
		onCancel={onCancel}
		title={<p><span>{title}:{row?.[field]}</span><span className="ml-20"> {t(`stock.RemainNumModal.index.商品编号`)}:{row?.materialCode}</span><span className="ml-20"> {t(`stock.RemainNumModal.index.商品名称`)}:{row?.materialName}</span></p>}
		width={1300}
		bodyHeight={550}
	>
		{type === "all" ? <div style={{ margin: "0 0 10px 10px" }}>
			<Button
				className={classname("io_spd")}
				shape="round"
				onClick={() => loadData("io_spd")}
			> {t(`stock.RemainNumModal.index.采购明细`)}</Button>
			<Button
				className={classname("io_sprd")}
				shape="round"
				onClick={() => loadData("io_sprd")}
			> {t(`stock.RemainNumModal.index.采退明细`)}</Button>
			<Button
				className={classname("io_ssd")}
				shape="round"
				onClick={() => loadData("io_ssd")}
			> {t(`stock.RemainNumModal.index.销售明细`)}</Button>
			<Button
				className={classname("io_ssrd")}
				shape="round"
				onClick={() => loadData("io_ssrd")}
			> {t(`stock.RemainNumModal.index.销退明细`)}</Button>
			<Button
				className={classname("io_vmm")}
				shape="round"
				onClick={() => loadData("io_vmm")}
			> {t(`stock.RemainNumModal.index.维修明细`)}</Button>
			<Button
				className={classname("io_vrm")}
				shape="round"
				onClick={() => loadData("io_vrm")}
			> {t(`stock.RemainNumModal.index.维退明细`)}</Button>
		</div > : <></>}

		<DetailsTable recordType={recordType} dataSource={dataSource} loading={loading} exportDetail={exportDetail} {...row} />
	</YHModal>
}